import { endOfDay, format, startOfDay, subDays } from "date-fns";
import ReactEcharts from "echarts-for-react";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import weui from "weui.js";
import indexImage from "../../assets/image/ex.png";
import { FlexBlock, GridItem, Grids, Loading } from "../../components/weui";
import { withMeterPicker } from "../../hooks/withMeterPicker";
import { commonService } from "../../services";
import { selectCurrentMeter } from "../../stores";
import { urls } from "../../urls";
import {
  dateParam,
  formatUsage2,
  getAxiosError
} from "../../utils";


const HomeInner = props => {
  const navigate = useNavigate();
  const meter = useSelector(selectCurrentMeter);
  const [reading, setReading] = useState();
  const [usages, setUsages] = useState();
  const [usagesDate, setUsagesDate] = useState();

  const usageUnit = useMemo(() => meter?.meterClass === "水表" ? "吨" : "度", [meter?.meterClass]);
  const unit = useMemo(() => reading?.calMode === 0 ? usageUnit : "元", [reading?.calMode, usageUnit]);

  const reload = useCallback(async () => {
    if (null == meter) return;

    const loading = weui.loading("加载中");
    try {
      // 加载剩余/用量数据
      let res = await commonService.reading(meter.meterNo);
      setReading(res.data);
      // 加载用量趋势数据
      const e = endOfDay(Date.now());
      const s = startOfDay(subDays(e, 30));
      res = await commonService.getUsages(meter.meterNo, "D", dateParam(s), dateParam(e));
      setUsages(res.data.details.map(d => d.zongLiangDay));
      setUsagesDate(res.data.details.map(d => format(subDays(new Date(d.chaoBiao), 1), "MM月dd日")));
    } catch (err) {
      weui.topTips(getAxiosError(err));
      setReading(null);
      setUsages(null);
      setUsagesDate(null);
    } finally {
      loading.hide();
    }
  }, [meter, setReading, setUsages, setUsagesDate]);

  useEffect(() => {
    reload();
  }, [reload]);

  const chartOpts = useMemo(() => ({
    title: {
      text: "最近 30 天日用量趋势",
      left: "center",
      textStyle: {
        fontSize: 13,
        color: "#888"
      }
    },
    tooltip: {},
    xAxis: {
      axisLabel: {
        interval: 5
      },
      axisPointer: {
        show: true
      },
      // splitLine: {show: true},
      data: usagesDate ?? []
    },
    yAxis: {},
    series: [{
      name: "日用量",
      type: "bar",
      data: usages ?? [],
      itemStyle: {
        color: "#fa5151"
      }
    }]
  }), [usages, usagesDate]);

  return (
    <>
      <div className="relative">
        <div className="pgBg" style={ { backgroundImage: `url(${indexImage})` } }></div>
        <div className="absolute inset-0">
          <div className="text-center text-xl font-semibold textCor pt-8 text-white"
            onClick={ e => props.showMeterPicker() }
            onKeyDown={ e => props.showMeterPicker() }
            role="button" tabIndex={ 0 }>
            { meter ? `${meter.name}[${meter.meterClass}]` : <Loading brand /> }
            <i className="iconfont icon-xiala text-white ml-2"></i>
          </div>
          <div className="text-center textCor text-base my-6 text-white">
            { meter ? `${meter.corpName} ${meter.meterNo}` : "......" }
          </div>
          <div className="boxShadow mAuto bgSelf w-10/12 haveborder py-3">
            <p className="text-center pb-3 textCor">
              { reading?.readingDate ? format(new Date(reading.readingDate), "yyyy年MM月dd日 HH:mm:ss") : "--" }
            </p>
            <div className="flex justify-between w-11/12 mAuto">
              <FlexBlock text="表计剩余"
                value={ reading ? formatUsage2(reading.shengYu) : "--" }
                unit={ unit } clW="w-1/2" />
              <FlexBlock text="本月用量"
                value={ reading && reading.usage ? formatUsage2(reading.usage) : "--" }
                unit={ usageUnit } clW="w-1/2" />
            </div>
          </div>
        </div>
      </div>

      <div className="mt-24 bgSelf">
        <Grids>
          <GridItem icon="icon-zhuzhuangtu" iconTitle="用量查询" onClick={ e => navigate(urls.bill()) } />
          <GridItem icon="icon-jiaoyijilu" iconTitle="缴费记录" onClick={ e => navigate(urls.payments()) } />
          <GridItem icon="icon-dianbiao" iconTitle="我的表计" onClick={ e => navigate(urls.meters()) } />
        </Grids>
      </div>

      <div className="mt-5 pt-10 bgSelf">
        <ReactEcharts option={ chartOpts } />
      </div>
    </>
  );
};

export const Home = withMeterPicker(HomeInner);
